

export function getCookie(cname) {
var el = window.elementn;
  if(window.location.href.indexOf("AF_language=en") > -1) {
    return "en";
 }
 else if(window.location.href.indexOf("AF_language=ar") > -1) {
   return "ar";
 }
 else
 {
   if(el != undefined && el.settings != null && el.settings.language != null)
   {
    return el.settings.language;
   }
   else
   {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "en";
   }

 }
    
  }
  


// WEBPACK FOOTER //
// ./src/utils/getCookie.js